import React from 'react';
import { CTAButton } from './CTAButton';
import { useScrollReveal } from './useScrollReveal';
export function ValueStack() {
  const ref = useScrollReveal();
  return <section id="comprar" className="w-full bg-white py-8 px-5 flex justify-center scroll-mt-4" data-id="element-191">
      <div ref={ref} className="fade-up w-full max-w-md flex flex-col gap-3" data-id="element-192">
        <h2 className="font-serif font-bold text-petroleo text-2xl leading-tight text-center" data-id="element-193">
          ¿Cuánto vale recuperar el control de tu cuerpo?
        </h2>
        <div className="bg-marfil rounded-xl p-4 border border-salvia-light shadow-sm flex flex-col gap-0" data-id="element-194">
          <div className="flex justify-between items-center py-2 border-b border-gray-200" data-id="element-195">
            <span className="text-gray-800 font-medium text-sm" data-id="element-196">
              6 Tomos del Protocolo
            </span>
            <span className="text-gray-800 font-semibold text-sm" data-id="element-197">$45.000</span>
          </div>
          <div className="flex justify-between items-center py-2 border-b border-gray-200" data-id="element-198">
            <span className="text-gray-800 font-medium text-sm" data-id="element-199">
              Bonus 1: Botón de Pánico
            </span>
            <div className="flex items-center gap-2" data-id="element-200">
              <span className="text-gray-400 line-through text-xs" data-id="element-201">
                $18.000
              </span>
              <span className="text-salvia font-bold text-xs" data-id="element-202">GRATIS</span>
            </div>
          </div>
          <div className="flex justify-between items-center py-2 border-b border-gray-200" data-id="element-203">
            <span className="text-gray-800 font-medium text-sm" data-id="element-204">
              Bonus 2: Calculadora de Alacena
            </span>
            <div className="flex items-center gap-2" data-id="element-205">
              <span className="text-gray-400 line-through text-xs" data-id="element-206">
                $14.000
              </span>
              <span className="text-salvia font-bold text-xs" data-id="element-207">GRATIS</span>
            </div>
          </div>
          <div className="flex justify-between items-center py-2 border-b border-gray-200" data-id="element-208">
            <span className="text-gray-800 font-medium text-sm" data-id="element-209">
              Bonus 3: Guía de Infusiones
            </span>
            <div className="flex items-center gap-2" data-id="element-210">
              <span className="text-gray-400 line-through text-xs" data-id="element-211">
                $12.000
              </span>
              <span className="text-salvia font-bold text-xs" data-id="element-212">GRATIS</span>
            </div>
          </div>
          <div className="flex justify-between items-center py-2" data-id="element-213">
            <span className="text-gray-500 font-medium text-sm" data-id="element-214">
              Valor total
            </span>
            <span className="text-gray-400 line-through text-base font-semibold" data-id="element-215">
              $89.000
            </span>
          </div>
          <div className="bg-blush-light rounded-lg mt-1 flex flex-col items-center justify-center gap-2 border border-blush p-3" data-id="element-216">
            <div className="flex items-center gap-2" data-id="element-217">
              <span className="text-petroleo font-medium text-xs" data-id="element-218">
                Hoy pagás
              </span>
              <span className="font-serif font-black text-petroleo text-2xl" data-id="element-219">
                $19.990
              </span>
            </div>
            <CTAButton text="Quiero mi Protocolo Ya!" isCheckout={true} data-id="element-220" />
          </div>
        </div>
        <p className="text-center text-gray-600 text-xs font-medium px-2" data-id="element-221">
          Menos que una consulta médica. Con resultados que podés empezar a ver
          en 5 días.
        </p>
      </div>
    </section>;
}